var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"message"},[_c('i',{staticClass:"material-icons"},[_vm._v("error_outline")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('errors.internal')))])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6df5b45b","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/errors/500.vue
// module id = 376
// module chunks = 0